import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SocialSecurityPipe } from './socialSecurity.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [SocialSecurityPipe],
    providers: [SocialSecurityPipe],
    exports: [SocialSecurityPipe],
})
export class SocialSecurityPipeModule {}
